import { DateTimeFormatter, LocalDate } from '@js-joda/core';
import { CreateSerializer } from './CreateSerializer';
/**
 * Serializer for LocalDates
 * Serialized format is "yyyy-MM-dd"
 */
export const localDateSerializer = CreateSerializer(serializeLocalDate, deserializeLocalDate);
function serializeLocalDate(value) {
    const date = Object.assign(LocalDate.now(), value);
    return date.format(DateTimeFormatter.ofPattern('yyyy-MM-dd'));
}
function deserializeLocalDate(value) {
    return LocalDate.parse(value);
}
